import { render, staticRenderFns } from "./hero-staked.vue?vue&type=template&id=d07570a4&scoped=true&"
import script from "./hero-staked.vue?vue&type=script&lang=ts&"
export * from "./hero-staked.vue?vue&type=script&lang=ts&"
import style0 from "./hero-staked.vue?vue&type=style&index=0&id=d07570a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07570a4",
  null
  
)

export default component.exports